import type { ReactNode } from 'react';
import type { GtinStatus, MatchStatus } from '@berytus/contracts';

export const MATCH: Record<MatchStatus, { label: string; tone: string; color: string }> = {
  matched: { label: 'Vinculado', tone: 'ok', color: 'var(--ok)' },
  unmatched: { label: 'Sem ficha central', tone: 'off', color: 'var(--line-strong)' },
  no_gtin: { label: 'Sem EAN', tone: 'warn', color: 'var(--chart-2)' },
  ambiguous: { label: 'Ambíguo', tone: 'warn', color: 'var(--warn)' },
  kit: { label: 'Kit', tone: 'info', color: 'var(--chart-1)' },
  manual: { label: 'Vínculo manual', tone: 'ok', color: 'var(--ok)' },
  pending: { label: 'Pendente', tone: 'off', color: 'var(--line-strong)' },
};

export const GTIN: Record<GtinStatus, { label: string; tone: string }> = {
  valid: { label: 'Válido', tone: 'ok' },
  internal_code: { label: 'Código interno', tone: 'off' },
  invalid_check_digit: { label: 'Dígito verificador errado', tone: 'err' },
  invalid_length: { label: 'Tamanho inválido', tone: 'err' },
  invalid_format: { label: 'Formato inválido', tone: 'err' },
};

export const SOURCE: Record<string, string> = {
  reference_code: 'EAN principal',
  reference_code_2: 'EAN 2',
  reference_code_3: 'EAN 3',
  'details.ean': 'EAN (detalhes)',
  'details.ean2': 'EAN 2 (detalhes)',
  api: 'API',
};

export function Tag({ tone, children }: { tone: string; children: ReactNode }) {
  return <span className={`tag ${tone}`}>{children}</span>;
}

export function MatchTag({ status }: { status: MatchStatus }) {
  const m = MATCH[status];
  return <Tag tone={m.tone}>{m.label}</Tag>;
}

export function Thumb({ src, alt }: { src: string | null; alt: string }) {
  return src ? <img className="thumb" src={src} alt={alt} loading="lazy" /> : <div className="thumb blank" aria-hidden />;
}

export function Loading() {
  return <p className="muted" role="status">Carregando…</p>;
}

export function ErrorBox({ error }: { error: unknown }) {
  return <div className="error">{error instanceof Error ? error.message : 'Não foi possível carregar.'}</div>;
}

const BUYBOX: Record<string, { label: string; tone: string }> = {
  winning: { label: 'Ganhando', tone: 'ok' },
  sharing_first_place: { label: 'Dividindo', tone: 'info' },
  competing: { label: 'Perdendo', tone: 'err' },
  listed: { label: 'Fora da disputa', tone: 'off' },
};

/** Situação do buy box de um anúncio de catálogo. */
export function buyBoxTag(status: string | null) {
  return status ? <Tag tone={BUYBOX[status]?.tone ?? 'off'}>{BUYBOX[status]?.label ?? status}</Tag> : null;
}
